<rds-header searchPosition="none" minimalMargins>
  <rds-divider rds-header-start-divider></rds-divider>
  <rds-header-app-name (triggered)="onAppNameTriggered($event)">
    Planwise 
    @if(url.includes('-dev')){ 
      <span>(DEV)</span>
    }
    @if(url.includes('localhost')){ 
      <span>(LOCAL)</span>
    }
    @if(url.includes('127')){ 
      <span>(LOCAL)</span>
    }
  </rds-header-app-name>
  @if (!isAdminPanel) {
    <rds-header-navigation-primary>
      <rds-global-search placeholder="Search everywhere..." size="s" includeButton
                  [(ngModel)]="globalSearch" (search)="onSearchChange($event)"
                  data-testid="global-search" class="header-search">
      </rds-global-search>
    </rds-header-navigation-primary>
  }

  <rds-header-actions>
    @if (isAdminPanel) {
      <button
        rds-text-button
        size="s"
        rdsTooltip="Back to main screen"
        (click)="onAppNameTriggered($event)"
      >
        <rds-icon namespace="outlined" icon="arrow_left"></rds-icon>
        Back to Main Screen
      </button>
    }

    <rds-divider rds-header-end-divider/>

    <app-user-info/>
  </rds-header-actions>
</rds-header>
@if(isDev) {
  <rds-alert type="warning">
    You are using the DEVELOPMENT environment, which is not guaranteed to be functional.
  </rds-alert>
}
@else {
  @if (shouldShowTransitionAlert()) {
    <rds-alert closable type="info">
      The transition to 1PRESS as the publication data source is complete.
    </rds-alert>
  }
}